// removed by extract-text-webpack-plugin
module.exports = {"empty-ribbon":"Ribbon__empty-ribbon","emptyRibbon":"Ribbon__empty-ribbon","ribbon-recommended":"Ribbon__ribbon-recommended","ribbonRecommended":"Ribbon__ribbon-recommended","ribbon":"Ribbon__ribbon"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Ribbon/Ribbon.css
// module id = 1237
// module chunks = 8